export default {
  templates: {
    // Traditional Wedding Tasks
    'choose-venue': {
      title: 'Choose the reception venue',
      description: 'Research and visit different venues for the ceremony and reception'
    },
    'define-budget': {
      title: 'Define the overall budget',
      description: 'Establish a detailed budget for each expense item'
    },
    'choose-date': {
      title: 'Choose the date',
      description: 'Set the wedding date based on venue and main vendors availability'
    },
    'book-venue': {
      title: 'Book the reception venue',
      description: 'Visit and book the venue for the ceremony and reception'
    },
    'choose-photographer': {
      title: 'Choose the photographer',
      description: 'Research and meet with photographers to select the one for your wedding'
    },
    'choose-caterer': {
      title: 'Choose the caterer',
      description: 'Research and select a caterer for the reception'
    },
    'choose-florist': {
      title: 'Choose the florist',
      description: 'Select a florist for ceremony and reception decorations'
    },
    'choose-music': {
      title: 'Choose the music',
      description: 'Select musicians or DJ for the ceremony and reception'
    },
    'choose-transport': {
      title: 'Choose transportation',
      description: 'Book transportation for the wedding day'
    },
    'choose-attire': {
      title: 'Choose wedding attire',
      description: 'Shop for wedding dress and groom\'s suit'
    },
    'choose-beauty': {
      title: 'Choose beauty services',
      description: 'Book hair and makeup services for the wedding day'
    },
    'send-invitations': {
      title: 'Send invitations',
      description: 'Design and send wedding invitations to guests'
    },
    'plan-honeymoon': {
      title: 'Plan honeymoon',
      description: 'Research and book honeymoon destination'
    },
    'legal-formalities': {
      title: 'Legal formalities',
      description: 'Complete all legal requirements for marriage'
    }
  }
};
